import { Button, Form, Popup, TextBox, SelectBox, List } from 'devextreme-react';
import { Label } from 'devextreme-react/bar-gauge';
import { SimpleItem, GroupItem } from 'devextreme-react/form';
import React, { useRef, useEffect } from 'react';
import { InputOnlyNumber, FormatLineNumber, FormatNumber } from '../../common';

const CusEntInsertPopup = ({
  onHiding,
  onValueChanged,
  onClickSave,
  cusEntInsertInfo,
  bankList,
  visibleCusEntInsertPopup,
  onClickInsert,
  textBoxValue,
  onValueChangedTextBox,
  lineNumberList,
  notifyMsg,
  accountTypeList,
  selectedDong,
  isOpened,
  onChange,
}) => {
  // console.log('CusEntInsertPopup Load');

  const refAccountNo = useRef(null);
  const refLineNumber = useRef(null);
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  useEffect(() => {

  }, [visibleCusEntInsertPopup]);

  return (
    <React.Fragment>
      <Popup
        title="업소고객추가"
        fullScreen={true}
        visible={visibleCusEntInsertPopup}
        onHiding={onHiding}
        className="popup"
        width="370px"
        height="310px"
        showCloseButton={true}
      >
        <div className="cusEnt-insert-popup">
            <div className="cusEnt-insert-popup-top">
                <div className="cusEnt-insert-popup-top-merge">
                    <div className="cusEnt-insert-content-left popup-content">
                        <Form formData={cusEntInsertInfo} labelLocation={'left'} minColWidth={50} width={"180px"}>
                            <GroupItem caption="업소고객 정보" className="cusEnt-info">
                                <SimpleItem>
                                    <Label text="업소명" />
                                    <TextBox
                                        width="6.5rem"
                                        readOnly={false}
                                        stylingMode='underlined'
                                        value={cusEntInsertInfo.cusEntName}
                                        onValueChanged={(e) => onValueChanged('cusEntName', e)}
                                    />
                                </SimpleItem>
                                <SimpleItem>
                                    <Label text="일반주소" />
                                    {/* <SelectBox
                                        dataSource={selectedDong}
                                        dropDownOptions={{minHeight: '0px'}}
                                        displayExpr="FullName"
                                        width="6.5rem"
                                        readOnly={false}
                                        searchEnabled={true}
                                        stylingMode='underlined'
                                        placeholder=''
                                        opened={isOpened}
                                        openOnFieldClick={false}
                                        minSearchLength={1}
                                        value={cusEntInsertInfo.dongCode}
                                        valueExpr="Code"
                                        onEnterKey={onChange}
                                        // onValueChanged={(e) => onValueChanged('dongCode', e)}
                                    /> */}
                                    <TextBox
                                        width="6.5rem"
                                        readOnly={false}
                                        stylingMode='underlined'
                                        value={cusEntInsertInfo.dongName}
                                        onValueChanged={(e) => onValueChanged('dongName', e)}
                                    />
                                </SimpleItem>
                                <SimpleItem>
                                    <Label text="상세주소" />
                                    <TextBox
                                        width="6.5rem"
                                        readOnly={false}
                                        stylingMode='underlined'
                                        value={cusEntInsertInfo.poiName}
                                        onValueChanged={(e) => onValueChanged('poiName', e)}
                                    />
                                </SimpleItem>
                                <SimpleItem>
                                    <Label text="메모" />
                                    <TextBox
                                        width="6.5rem"
                                        readOnly={false}
                                        stylingMode='underlined'
                                        value={cusEntInsertInfo.memo}
                                        onValueChanged={(e) => onValueChanged('memo', e)}
                                    />
                                </SimpleItem>
                            </GroupItem>
                        </Form>
                        <Form labelLocation={'left'} minColWidth={30} width={"180px"}>
                            <GroupItem caption="업소 전화번호" className="cusEnt-info">
                                <SimpleItem>
                                    <Label text="번호"/>
                                    <div className="flex-row">
                                        <TextBox
                                            width="6.25rem"
                                            readOnly={false}
                                            stylingMode='underlined'
                                            value={textBoxValue}
                                            onInput={(e) =>
                                                InputOnlyNumber(e.event, refLineNumber.current)
                                            }
                                            onValueChanged={onValueChangedTextBox}
                                        />
                                        <Button
                                            stylingMode="contained"
                                            type="default"
                                            icon="plus"
                                            onClick={onClickInsert}
                                        />
                                    </div>
                                </SimpleItem>
                                <SimpleItem>
                                    <List
                                        width="10.5rem"
                                        className="lineNumber-List"
                                        dataSource={lineNumberList}
                                        height={120}
                                        displayExpr={(item) => `${FormatLineNumber(item.lineNumber)}`}
                                        selectionMode='single'
                                        selectbyClick={true}
                                        allowItemDeleting={true}
                                        itemDeleteMode='static'
                                        noDataText="전화번호를 입력해주세요"
                                    />
                                </SimpleItem>
                            </GroupItem>
                        </Form>
                    </div>
                    <div className="cusEnt-insert-content-right popup-content">
                        <Form formData={cusEntInsertInfo} labelLocation={'left'} minColWidth={50} width={"180px"}>
                            <GroupItem caption="정산정보"  className="cusEnt-info">
                                <SimpleItem>
                                    <Label text="웹아이디" />
                                    <TextBox
                                        width="5.75rem"
                                        readOnly={false}
                                        stylingMode='underlined'
                                        value={cusEntInsertInfo.webID}
                                        onValueChanged={(e) => onValueChanged('webID', e)}
                                    />
                                </SimpleItem>
                                <SimpleItem>
                                    <Label text="웹비밀번호" />
                                    <TextBox
                                        width="5.75rem"
                                        readOnly={false}
                                        stylingMode='underlined'
                                        value={cusEntInsertInfo.webPassword}
                                        onValueChanged={(e) => onValueChanged('webPassword', e)}
                                    />
                                </SimpleItem>
                                <SimpleItem>
                                    <Label text="정산타입" />
                                    <SelectBox
                                        dataSource={accountTypeList}
                                        displayExpr="Value"
                                        width="5.75rem"
                                        readOnly={false}
                                        stylingMode='underlined'
                                        value={cusEntInsertInfo.accountType}
                                        valueExpr="Code"
                                        onValueChanged={(e) => onValueChanged('accountType', e)}
                                    />
                                </SimpleItem>
                                <SimpleItem>
                                    <Label text="콜당금액" />
                                    <TextBox
                                        width="5.75rem"
                                        readOnly={false}
                                        stylingMode='underlined'
                                        value={FormatNumber(cusEntInsertInfo.commission)}
                                        onInput={(e) =>
                                            InputOnlyNumber(e.event)
                                        }
                                        onValueChanged={(e) => onValueChanged('commission', e)}
                                    />
                                </SimpleItem>
                                <SimpleItem>
                                    <Label text="최소콜수" />
                                    <TextBox
                                        width="5.75rem"
                                        readOnly={false}
                                        stylingMode='underlined'
                                        value={cusEntInsertInfo.minCompleteCnt}
                                        onInput={(e) =>
                                            InputOnlyNumber(e.event)
                                        }
                                        onValueChanged={(e) => onValueChanged('minCompleteCnt', e)}
                                    />
                                </SimpleItem>
                                <SimpleItem>
                                    <Label text="은행명" />
                                    <SelectBox
                                        dataSource={bankList}
                                        displayExpr="Value"
                                        width="5.75rem"
                                        readOnly={false}
                                        stylingMode='underlined'
                                        placeholder=''
                                        value={cusEntInsertInfo.bankCode}
                                        valueExpr="Code"
                                        onValueChanged={(e) => onValueChanged('bankCode', e)}
                                    />
                                </SimpleItem>
                                <SimpleItem>
                                    <Label text="계좌번호" />
                                    <TextBox
                                        width="5.75rem"
                                        readOnly={false}
                                        stylingMode='underlined'
                                        value={cusEntInsertInfo.accountNo}
                                        onInput={(e) =>
                                            InputOnlyNumber(e.event, refAccountNo.current)
                                        }
                                        onValueChanged={(e) => onValueChanged('accountNo', e)}
                                    />
                                </SimpleItem>
                                <SimpleItem>
                                    <Label text="예금주" />
                                    <TextBox
                                        width="5.75rem"
                                        readOnly={false}
                                        stylingMode='underlined'
                                        value={cusEntInsertInfo.bankOwnerName}
                                        onValueChanged={(e) => onValueChanged('bankOwnerName', e)}
                                    />
                                </SimpleItem>
                            </GroupItem>
                        </Form>
                    </div>
                </div>
            </div>
            <div className="cusEnt-insert-content-bottom">
            {/* <span className="notify-error"> notifyMsg </span> */}
            <Button
                stylingMode="contained"
                type="default"
                text="저장"
                onClick={onClickSave}
            />
            </div>
            <div className="notify">
                <span className="notify-error"> {notifyMsg} </span>
            </div>
        </div>
      </Popup>
    </React.Fragment>
  );
};

export default React.memo(CusEntInsertPopup);
